import React, { useEffect, useState } from 'react';
import Params from '../../../../Types/ParamsPicklist';
import { Box, CircularProgress, Grid, TextField, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import axios from 'axios';
import { Crypter } from '../../../../Functions/Security/Crypter';
import DataType from '../../../../Types/DataTablePiclist';
import Datas from '../../../../Data/Data.json'
import SelectMultipleOptionPanier from '../../../SelectMultipleOptionPanier';


// let searchPlanCpte: Params = { CodeAgence: '', Table: "V_COMPTE_CLIENTELE_PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchFinancement  : Params = { CodeAgence: '', Table: "TypeGarantie", Colonne1: "CodeTypeGarantie", Colonne2: "LibelleGarantie", Colagence: '101', Choix: 22 }
//let searchPlancp: Params = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Choix: 22 }

let searchPlancp: Params = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL",Colagence: "", Choix: 39,tablelength:'societe',collength:'LenPlancp' }
  

function Tab3(props: { form?: any }) {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  
 
  return (
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
           <Grid item xs={12} md={12}  lg={12} >
                <SelectMultipleOptionPanier    form={props.form}  Size="large"  width={4}  label="Type de Garantie Autorise"  name="TypeGarantieAuto"  Parametre={searchFinancement} />
             </Grid>
             <Grid item xs={12} md={12}  lg={12} style={{ marginTop: '20px', marginBottom: '20px' }}>
                 <SelectMultipleOptionPanier   form={props.form} Size="large"  width={4}  label="Plan comptable remboussement"  name="ComptesRemboursementAuto" Parametre={searchPlancp}  />
           </Grid>
        </Box>
      </div>
    </div>
  )
}

export default Tab3;  
